import api from "../../config/axios";

export class LoanService {
    async getLoanDetails() {
        const response = await api.get(`/loan/details`);
        return response.data;
    }

    async getLoanTransactions() {
        const response = await api.get(`/loan/transactions`);
        return response.data;
    }
}

const loanService = new LoanService();
export default loanService;